export const ERROR_DETAILS_HEADER = 'We can’t save your class right now'
export const errorDetailsHeaderStatus = status => {
  return `We can’t ${status.toLowerCase()} your class right now`
}
export const ERROR_DETAILS_SUBHEADER = `#### There’s been a server error.  
  #### Wait a few minutes before trying again.`
export const ERROR_DETAILS_BODYCOPY = `If you have questions, contact us: support@secondstep.org  
  800-634-4449,&nbsp;ext 1 or&nbsp;206-343-1223`
export const ERROR_DETAILS_CLOSE = 'Close'
